module.exports={
    logout  : "Numéro de compte d'annulation",
    my      :'La mienne.',
    scqx    :'Supprimer les permissions',
    qxgl    :'Gestion des droits',
    qdzxzhm :'Êtes - vous sûr de vouloir annuler votre compte?',
    qtxkh   :'Veuillez remplir le numéro de carte',
    qd      :'Cest sûr.',
    qx      :'Annulation',
    gb      :'Fermer',
    kh      :'Numéro de la carte',
    kmewm   :'Code QR douverture de porte',
    dl      :'Connexion',
    name    :'Nom dutilisateur',
    qtxname :'Veuillez remplir le nom dutilisateur',
    pwas    :'Mot de passe',
    qtxpwas :'Veuillez remplir le mot de passe',
    tj      :'Présentation',
    zczh    :'Numéro de compte enregistré',
    zc      :'Inscription',
    sjhm    :'Numéro de téléphone portable',
    qtxsjhm :'Veuillez remplir le numéro de téléphone mobile',
    yzm     :'Code de vérification',
    qtxyzm  :'Veuillez remplir le Code de vérification',
    yyzhqqdl:'Vous avez déjà un compte. Allez vous connecter.',
    hqyzm   :'Obtenir le Code de vérification',
    zccg    :'Inscription réussie',
    zcsb    :'Échec de linscription',
    fscg    :'Envoyé avec succès',
    fssb    :'Échec de lenvoi',
    yhycz   :'Lutilisateur existe déjà'
}